import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=d648d0d6&scoped=true"
import script from "./BasketItem.vue?vue&type=script&lang=js"
export * from "./BasketItem.vue?vue&type=script&lang=js"
import style0 from "./BasketItem.vue?vue&type=style&index=0&id=d648d0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d648d0d6",
  null
  
)

export default component.exports